<div id="kt_scrolltop" class="scrolltop">
		<i class="icon-xl fas fa-arrow-up"></i>
</div>